import { Logo } from "@/components/Logo";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SubscribeSuccess() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setStatus("error");
      return;
    }

    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      if (attempts.current >= 8) {
        setStatus("timeout");
        return;
      }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/billing/checkout-status/${sessionId}`);
        if (data.payment_status === "paid") {
          await refresh();
          setStatus("paid");
          return;
        }
        if (data.status === "expired") {
          setStatus("expired");
          return;
        }
      } catch (e) {}
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [refresh]);

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center px-6">
      <div className="text-center max-w-[380px]">
        {status === "checking" && (
          <>
            <Loader2 className="h-12 w-12 animate-spin text-[#ccff0c] mx-auto mb-4" />
            <h1 className="font-display text-2xl font-bold">Confirming your payment…</h1>
            <p className="text-muted-foreground mt-2">Hang tight, this only takes a moment.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <Logo className="h-20 w-20 rounded-2xl mx-auto mb-4" />
            <h1 className="font-display text-3xl font-bold">You're in!</h1>
            <p className="text-muted-foreground mt-2 mb-6">Your subscription is active. Time to get after it.</p>
            <Button data-testid="success-continue" onClick={() => navigate("/dashboard")} className="bg-[#ccff0c] text-black hover:bg-[#d7ff3a] rd-glow font-semibold h-12 px-8">Go to Dashboard</Button>
          </>
        )}
        {(status === "error" || status === "expired" || status === "timeout") && (
          <>
            <XCircle className="h-14 w-14 text-red-400 mx-auto mb-4" />
            <h1 className="font-display text-2xl font-bold">Payment not completed</h1>
            <p className="text-muted-foreground mt-2 mb-6">{status === "timeout" ? "We couldn't confirm your payment yet. Check your dashboard shortly." : "Something went wrong with checkout."}</p>
            <Button data-testid="success-retry" onClick={() => navigate("/subscribe")} className="bg-secondary text-foreground border border-border h-12 px-8">Back to plans</Button>
          </>
        )}
      </div>
    </div>
  );
}
